import * as z from 'zod';
import {translations} from 'presentation/translations-new';
import {currencyHandle} from 'presentation/utils/currencyHandle';

const {requiredField} = translations['pt-br'].commons;
const {valueGreaterThan2Cents} = translations['pt-br'].privateFlow.refund.validations;

function currencyValueIsGreaterThan(value: string, minValue: number) {
	const currency = currencyHandle().fromString(value);
	return currency.isGreaterThan(currencyHandle(minValue).getValue());
}

export const fiscalDocumentSchema = z
	.object({
		canEmitFiscalDocument: z.enum(['yes', 'no']),
		numFiscalDocument: z.string().min(1, {message: requiredField}),
		verifyCode: z.string().optional(),
		priceFiscalDocument: z.string().refine(value => currencyValueIsGreaterThan(value, 0.02), {
			message: valueGreaterThan2Cents,
		}),
		state: z
			.object({
				state: z.string().optional(),
				code: z.string().optional(),
			})
			.optional()
			.nullable(),
		city: z
			.object({
				city: z.string().optional(),
				ibgedocumentcity: z.string().optional(),
				citycode: z.string().optional(),
			})
			.optional()
			.nullable(),
		termsChecked: z.boolean().optional(),
	})
	.superRefine((data, ctx) => {
		if (data?.canEmitFiscalDocument === 'yes') {
			if (!data?.verifyCode?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['verifyCode'],
					message: requiredField,
				});
			}
			if (!data?.state?.state?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['state', 'state'],
					message: requiredField,
				});
			}

			if (!data?.state?.code?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['state', 'code'],
					message: requiredField,
				});
			}

			if (!data?.city?.city?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['city', 'city'],
					message: requiredField,
				});
			}

			if (!data?.city?.ibgedocumentcity?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['city', 'ibgedocumentcity'],
					message: requiredField,
				});
			}

			if (!data?.city?.citycode?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['city', 'citycode'],
					message: requiredField,
				});
			}
		}

		if (data?.canEmitFiscalDocument === 'no' && !data?.termsChecked) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['termsChecked'],
				message: requiredField,
			});
		}
	});

export type FiscalDocumentSchema = z.infer<typeof fiscalDocumentSchema>;
